import { I } from '@angular/cdk/keycodes';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, computed, Input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { fadeInLeftAnimation } from 'src/app/shared/animations/animations';
import { environment } from 'src/environments/environment';

/** 
 * questo componente mostra na promo generica singola a tutta larghezza per il marketplace.
 * Contiene una immagine di sfondo, una descrizione e un bottone che porta al marketplace
 *  */

@Component({
  selector: 'app-promo-marketplace',
  templateUrl: './promo-marketplace.component.html',
  standalone: true,
  imports: [CommonModule,
    NgOptimizedImage,
    MatCardModule,
    MatButtonModule,
    TranslateModule
  ],
  animations: [fadeInLeftAnimation],
  styleUrls: ['./promo-marketplace.component.scss']
})
export class PromoMarketplaceComponent {
  @Input() title!: string;
  @Input() template!: 'marketplace' | 'project' | 'orders' | null ;
  @Input() promo: string = 'promo.promo_marketplace';
  
  template$ = signal<'project' | 'marketplace' | 'orders' | null>(null);
  
  promoMarketplace$:Observable<string> = new Observable<string>();
  bgIdx$ = computed(() => {
  switch (this.template$()) {
    case 'marketplace':
      return 'bg-gradient-4';
    case 'orders':
      return 'bg-gradient-4';
    case 'project':
      return 'bg-gradient-3';
    default:
      return 'bg-gradient-3';
  }
})
  imgBg$ = computed(() => {
    if (this.template$() === 'marketplace') {
      return '/images/promo/promo-marketplace.webp';
    } else {
      return '/images/promo/promo-projects.webp';
    }
  });

  constructor(private router: Router,
    private translateService: TranslateService
  ) {
  }
  
  ngOnInit(): void { 
    this.template$.set(this.template);
    this.promoMarketplace$ = this.translateService.get(this.promo)
  }

  GoToMarketplace() {
    this.router.navigate([environment.routingBasePath + '/marketplace']);
  }

}
